// extracted by mini-css-extract-plugin
export default {"companySelect":"portals_companySelect__7nJVd"};